module.exports = __webpack_public_path__ + "static/media/icon_01.e0e5f301.png";